import React from 'react';
import MessageContent from 'components/messages/MessageContent';
import Message from 'components/Message';

const ValidateEmailSuccess = ({ onDismiss }) => (
  <Message
    type="info"
    onDismiss={onDismiss}
    message={(
      <MessageContent>
        Thank you! Your email was verified, please sign
        in again to complete your set-up.
      </MessageContent>
    )}
  />
);

ValidateEmailSuccess.displayName = 'SendCodeSuccess';

ValidateEmailSuccess.propTypes = {
  onDismiss: Message.propTypes.onDismiss.isRequired,
};

export default ValidateEmailSuccess;
